import { PlusCircleOutlined } from '@ant-design/icons'
import { GraviButton, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Row } from 'antd'
import React, { useState } from 'react'

import { useSecurityContext } from '../../../../Navigation/SecurityContext'
import { BlendRows } from './Rows'

export function Blends({ products, selectedProduct, updateRow }) {
  const { scopes } = useSecurityContext()
  const [editMode, setEditMode] = useState(false)

  const canEditProductConfig = scopes.admin?.site_write

  const addBlend = () => {
    const newComponent = { name: '', percentage: '' }
    const blendComponents = [newComponent, newComponent]
    const blends = selectedProduct.blends || []
    setEditMode(true)
    const updatedProduct = {
      ...selectedProduct,
      blends: [...blends, { name: '', components: blendComponents }],
    }
    updateRow(updatedProduct)
  }

  return (
    <>
      <Row style={{ minHeight: 60, borderBottom: 'solid 1px var(--gray-300)', background: 'var(--bg-2)' }}>
        <Vertical flex={6} className='p-3 pb-4' verticalCenter>
          <Texto category='h5' className='mb-2' weight='bold'>
            Blends
          </Texto>
          <Texto appearance='medium'>
            Add blends for this product here to model different component combinations in the system.
          </Texto>
        </Vertical>
        <Vertical flex={1} verticalCenter>
          {canEditProductConfig && (
            <GraviButton buttonText='Create Blend' theme2 onClick={addBlend} icon={<PlusCircleOutlined />} />
          )}
        </Vertical>
      </Row>

      <BlendRows
        editable={editMode}
        updateRow={updateRow}
        setEditMode={setEditMode}
        products={products}
        selectedProduct={selectedProduct}
      />
    </>
  )
}
